import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar/Navbar';
import PageLayout from './PageLayout';
import { measureViewportSize, watchViewportSize } from 'phaser-wars';

export default function AppLayout() {
  const shellRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = shellRef.current;
    if (!el) {
      return;
    }
    // Same cold-load settle as the canvas routes: on iOS standalone the
    // CSS viewport units (100dvh) can resolve stale-small at launch and
    // never correct until a rotation forces a relayout. Take the shell over
    // with explicit pixel sizing measured from the layout viewport,
    // re-applied by the settle loop. The layout viewport (not the visual
    // viewport) is deliberate: these pages have real text inputs, and the
    // visual viewport shrinks when the on-screen keyboard opens.
    const unsubscribe = watchViewportSize(
      () => measureViewportSize('layout'),
      (size) => {
        el.style.width = `${size.width}px`;
        el.style.height = `${size.height}px`;
      },
      { initial: true, listenWindowResize: true }
    );
    return unsubscribe;
  }, []);

  return (
    // Fixed-height flex column: the navbar stays pinned while only the
    // inner content area scrolls. html/body are left scrollable globally
    // (see index.css); this shell is the one place all normal-flow pages
    // get their scrolling. Its height is driven by the settle loop above
    // (see .app-shell for the pre-JS CSS fallback).
    <div ref={shellRef} className="app-shell">
      <Navbar />
      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        <PageLayout>
          <Outlet />
        </PageLayout>
      </div>
    </div>
  );
}
